import React, { useMemo } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function SubscriberProfile() {
  const { id } = useParams();
  const navigate = useNavigate();

  const subs = useMemo(
    () => ({
      1: { id: 1, name: 'Ava Smith', email: 'ava.smith@example.com', phone: '+1-256-325-8652', image: '/assets/img/vendor/u1.jpg', bought: 10, wishlist: 3, following: 15 },
      2: { id: 2, name: 'Johnee Bolbi', email: 'johnee.bolbi@example.com', phone: '+5-256-325-8652', image: '/assets/img/vendor/u2.jpg', bought: 5, wishlist: 1, following: 9 },
      3: { id: 3, name: 'Mohini Marlo', email: 'mohini.marlo@example.com', phone: '+91-154-325-8652', image: '/assets/img/vendor/u4.jpg', bought: 3, wishlist: 2, following: 5 },
    }),
    []
  );

  const user = subs[id] || subs[1];

  return (
    <>
      <Helmet>
        <title>{user ? `${user.name} | Subscriber` : 'Subscriber Profile'} | Owena Admin Dashboard</title>
      </Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>User Profile</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e) => { e.preventDefault(); navigate('/dashboard'); }}>Home</a></span>
                <span><i className="mdi mdi-chevron-right"></i></span>Profile</p>
            </div>
            <div>
              <Link to="/subscribers" className="btn btn-primary">Edit</Link>
            </div>
          </div>
          <div className="card bg-white profile-content">
            <div className="row">
              <div className="col-lg-4 col-xl-3">
                <div className="profile-content-left profile-left-spacing">
                  <div className="text-center widget-profile px-0 border-0">
                    <div className="card-img mx-auto rounded-circle">
                      <img src={user.image} alt="user image" />
                    </div>
                    <div className="card-body">
                      <h4 className="py-2 text-dark">{user.name}</h4>
                      <p>{user.email}</p>
                      <a className="btn btn-primary my-3" href="#" onClick={(e) => e.preventDefault()}>Follow</a>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <div className="text-center pb-4">
                      <h6 className="text-dark pb-2">{user.bought}</h6>
                      <p>Bought</p>
                    </div>
                    <div className="text-center pb-4">
                      <h6 className="text-dark pb-2">{user.wishlist}</h6>
                      <p>Wish List</p>
                    </div>
                    <div className="text-center pb-4">
                      <h6 className="text-dark pb-2">{user.following}</h6>
                      <p>Following</p>
                    </div>
                  </div>
                  <hr className="w-100" />
                  <div className="contact-info pt-4">
                    <h5 className="text-dark">Contact Information</h5>
                    <p className="text-dark font-weight-medium pt-24px mb-2">Email address</p>
                    <p>{user.email}</p>
                    <p className="text-dark font-weight-medium pt-24px mb-2">Phone Number</p>
                    <p>{user.phone}</p>
                    <p className="text-dark font-weight-medium pt-24px mb-2">Birthday</p>
                    <p>Dec 10, 1991</p>
                    <p className="text-dark font-weight-medium pt-24px mb-2">Social Profile</p>
                    <p className="social-button">
                      <a href="#" className="mb-1 btn btn-outline btn-twitter rounded-circle" onClick={(e) => e.preventDefault()}><i className="mdi mdi-twitter"></i></a>
                      <a href="#" className="mb-1 btn btn-outline btn-linkedin rounded-circle" onClick={(e) => e.preventDefault()}><i className="mdi mdi-linkedin"></i></a>
                      <a href="#" className="mb-1 btn btn-outline btn-facebook rounded-circle" onClick={(e) => e.preventDefault()}><i className="mdi mdi-facebook"></i></a>
                      <a href="#" className="mb-1 btn btn-outline btn-skype rounded-circle" onClick={(e) => e.preventDefault()}><i className="mdi mdi-skype"></i></a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-xl-9">
                <div className="profile-content-right profile-right-spacing py-5">
                  <ul className="nav nav-tabs px-3 px-xl-5 nav-style-border" id="myProfileTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="true">Profile</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="settings-tab" data-bs-toggle="tab" data-bs-target="#settings" type="button" role="tab" aria-controls="settings" aria-selected="false">Settings</button>
                    </li>
                  </ul>
                  <div className="tab-content px-3 px-xl-5" id="myTabContent">
                    <div className="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                      <div className="tab-widget mt-5">
                        <div className="row">
                          <div className="col-xl-4">
                            <div className="media widget-media p-3 bg-white border">
                              <div className="icon rounded-circle mr-3 bg-primary"><i className="mdi mdi-account-outline text-white "></i></div>
                              <div className="media-body align-self-center"><h4 className="text-primary mb-2">{user.bought}</h4><p>Bought</p></div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="media widget-media p-3 bg-white border">
                              <div className="icon rounded-circle bg-warning mr-3"><i className="mdi mdi-cart-outline text-white "></i></div>
                              <div className="media-body align-self-center"><h4 className="text-primary mb-2">1953</h4><p>Wish List</p></div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="media widget-media p-3 bg-white border">
                              <div className="icon rounded-circle mr-3 bg-success"><i className="mdi mdi-ticket-percent text-white "></i></div>
                              <div className="media-body align-self-center"><h4 className="text-primary mb-2">02</h4><p>Voucher</p></div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12">
                            <div className="card card-default">
                              <div className="card-header justify-content-between mb-1"><h2>Latest Notifications</h2></div>
                              <div className="card-body compact-notifications" style={{ height: '434px', overflow: 'auto' }}>
                                <div className="media pb-3 align-items-center justify-content-between">
                                  <div className="d-flex rounded-circle align-items-center justify-content-center mr-3 media-icon iconbox-45 bg-primary text-white"><i className="mdi mdi-cart-outline font-size-20"></i></div>
                                  <div className="media-body pr-3 "><a className="mt-0 mb-1 font-size-15 text-dark" href="#" onClick={(e) => e.preventDefault()}>New Order</a><p>Selena has placed a new order</p></div>
                                  <span className=" font-size-12 d-inline-block"><i className="mdi mdi-clock-outline"></i> 10 AM</span>
                                </div>
                              </div>
                              <div className="mt-3"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane fade" id="settings" role="tabpanel" aria-labelledby="settings-tab">
                      <div className="tab-pane-content mt-5">
                        <form onSubmit={(e) => e.preventDefault()}>
                          <div className="row mb-2">
                            <div className="col-lg-6"><div className="form-group"><label htmlFor="firstName">First name</label><input type="text" className="form-control" id="firstName" defaultValue={user.name.split(' ')[0]} /></div></div>
                            <div className="col-lg-6"><div className="form-group"><label htmlFor="lastName">Last name</label><input type="text" className="form-control" id="lastName" defaultValue={user.name.split(' ').slice(1).join(' ')} /></div></div>
                          </div>
                          <div className="form-group mb-4"><label htmlFor="userName">User name</label><input type="text" className="form-control" id="userName" defaultValue={user.name.replace(/\s+/g, '.').toLowerCase()} /><span className="d-block mt-1">Update your profile information.</span></div>
                          <div className="form-group mb-4"><label htmlFor="email">Email</label><input type="email" className="form-control" id="email" defaultValue={user.email} /></div>
                          <div className="d-flex justify-content-end mt-5"><button type="submit" className="btn btn-primary mb-2 btn-pill">Update Profile</button></div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubscriberProfile;


